import classnames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import styles from './FieldDraftContent.module.css'
import { sanitize } from './sanitize'

type Props = {
  content: string
  className?: string
}

export const FieldDraftContent: FC<Props> = ({ content, className }) => {
  const sanitizedContent = useMemo(() => {
    return sanitize(content)
  }, [content])

  return (
    <div
      className={classnames(styles.DraftContent, className)}
      dangerouslySetInnerHTML={{
        __html: sanitizedContent
      }}
    />
  )
}
